// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCxUdBrv4ZWD_QSVqhv-TwlcEGi7prDd28",

  authDomain: "saunamaster.firebaseapp.com",

  projectId: "saunamaster",

  storageBucket: "saunamaster.firebasestorage.app",

  messagingSenderId: "809778400325",

  appId: "1:809778400325:web:6adfc7ce0f50e19124e72c"

};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
let analytics = null;

function initAnalytics() {
  const consent = localStorage.getItem("cookiesConsent");
  if (consent) {
    try {
      analytics = getAnalytics(app);
    } catch (error) {
      console.warn("Firebase Analytics nie jest dostępne lub wystąpił błąd:", error);
      analytics = null;
    }
  }
}

function getAnalyticsInstance() {
  return analytics;
}
export { initAnalytics, getAnalyticsInstance };
